import EventBus from "@/lib/eventBus"
import User from "@/lib/user"

export default {
  watch: {
    title: function(newValue, oldValue) {
      EventBus.$emit("title", this.title)
    }
  },
  mounted: function() {
    EventBus.$emit("title", this.title)
  },
  beforeDestroy() {
    EventBus.$emit("title", undefined)
  }
}
